module.exports = __webpack_public_path__ + "static/media/loc_yout.0c019cfe.png";